// docs/37 LN5 — the lobby's name, the label friends find the World by. The keeper renames it here
// (the World lobby's options and the in-game Settings → World tab) at any phase; everyone else
// sees it read-only. Renaming never touches the World's own name, which is the storyteller's.
import { useEffect, useState } from 'react';
import { Field, Input } from '../components';
import { rpc } from '../../core/net/reducers';

export const LOBBY_NAME_MAX = 40;

export function LobbyNameField({ worldId, name, keeper, testId, id, className, hint }: { worldId: bigint; name: string; keeper: boolean; testId: string; id: string; className?: string; hint?: string }) {
  const [text, setText] = useState(name);
  useEffect(() => { setText(name); }, [name]);
  const commit = () => {
    const t = text.trim();
    if (!keeper || t === name) return;
    if (!t) { setText(name); return; }
    void rpc.renameLobby(worldId, t).then((r) => { if (!r.ok) setText(name); });
  };
  return (
    <Field label="Lobby name" hint={hint ?? (keeper ? 'friends find this World by it' : 'set by the keeper')} htmlFor={id} className={className}>
      <Input id={id} data-testid={testId} value={text} disabled={!keeper} maxLength={LOBBY_NAME_MAX} onChange={(e) => setText(e.target.value)} onBlur={commit}
        onKeyDown={(e) => { if (e.key === 'Enter') (e.target as HTMLInputElement).blur(); if (e.key === 'Escape') setText(name); }} />
    </Field>
  );
}
